import { render } from "./UnicefButton.vue?vue&type=template&id=63e4b1d5&scoped=true"
import script from "./UnicefButton.vue?vue&type=script&lang=js"
export * from "./UnicefButton.vue?vue&type=script&lang=js"

import "./UnicefButton.vue?vue&type=style&index=0&id=63e4b1d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e4b1d5"]])

export default __exports__